import {
    useContext,
    type FC
} from "react";
import type IDropdownMenuSubContentProps from "./type";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useDropdownMenuLevelContext,
    DropdownMenuSubContext,
    useDropdownMenuContext
} from "../../context";
import {
    focusDropdownMenuElement
} from "../../util";
import DropdownMenuSurface from "../surface";

const DropdownMenuSubContent: FC<IDropdownMenuSubContentProps> = ({
    customTheme: customThemeProp,
    children,
    style
}) => {
    const rootContext = useDropdownMenuContext({
        part: "SubContent"
    });

    const levelContext = useDropdownMenuLevelContext({
        part: "SubContent"
    });

    const subContext = useContext(DropdownMenuSubContext);

    const customTheme = customThemeProp ?? rootContext?.customTheme;

    const {
        borders,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const {
        direction
    } = NCoreUIKitLocalize.useContext();

    if(!rootContext || !levelContext || !subContext) {
        return null;
    }

    const handleDismiss = () => {
        subContext.handleOpenChange(false);
    };

    const handleCloseSub = () => {
        subContext.handleOpenChange(false);

        focusDropdownMenuElement(subContext.anchorRef.current);
    };

    return <DropdownMenuSurface
        isOpen={subContext.isOpen && rootContext.isOpen}
        side={direction === "rtl" ? "left" : "right"}
        offset={spaces.spacingXs * 2 + borders.line}
        aria-labelledby={subContext.triggerId}
        anchorRef={subContext.anchorRef}
        level={levelContext.level + 1}
        openMode={subContext.openMode}
        onCloseSub={handleCloseSub}
        onDismiss={handleDismiss}
        customTheme={customTheme}
        style={style}
        align="start"
    >
        {children}
    </DropdownMenuSurface>;
};
export default DropdownMenuSubContent;
